// Mã riêng của lần mở trang này (mỗi tab một mã, tải lại trang thì đổi mã). Các tab cùng trình
// duyệt dùng chung device_id, nên BE cần mã này để nhận ra đúng tab vừa thao tác: socket chỉ tắt
// toast/âm thanh ở tab đó, tab khác (vd màn Chế biến/Lên món) vẫn báo như máy khác.
// Cố ý không lưu sessionStorage: nhân bản tab sẽ chép mã sang tab mới.
const clientInstanceId =
    typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;

export function getClientInstanceId() {
    return clientInstanceId;
}
